export const USER_INITIALS = [
  { email: "dan.longo@webedia-group.com", initials: "DL" },
];
